import { onUnmounted, ref, watch } from '@vue/composition-api'
import store from '@/store'
import filterStore from '../Utils/filterStore'

export default function useGeofenceFilter(){


  const gOwnersOptions = ref([])
  const gCategoriesOptions = ref([])
  const gTypesOptions = ref([])
  const gGroupsOptions = ref([])
  const gContractsOptions = ref([])
  const gContractsOptions_orig=ref([])
  const gDevicesOptions = ref([])

  const gCategoriesFilter = ref([])
  const gOwnersFilter = ref([])
  const gTypeFilter = ref(null)
  const gGroupFilter = ref(null)
  const gContractsFilter = ref([])
  const gDeviceFilter = ref(null)


  const FILTER_STORE = 'filterStore'

  // Register module
  if (!store.hasModule(FILTER_STORE))
       store.registerModule(FILTER_STORE, filterStore)

  // UnRegister on leave
  onUnmounted(() => {
    if (store.hasModule(FILTER_STORE))
        store.unregisterModule(FILTER_STORE)
  })


  store.dispatch('filterStore/getFilterOptionsBy',
    {user: store.getters['auth/user'].id, 'type':'geofence'})
    .then(res => {
          gContractsOptions.value = res.data.data.contracts
          gContractsOptions_orig.value=res.data.data.contracts
          gGroupsOptions.value = res.data.data.groups
          gTypesOptions.value = res.data.data.types
          gOwnersOptions.value = res.data.data.owners
          gCategoriesOptions.value = res.data.data.categories
          gDevicesOptions.value = res.data.data.devices
    }).catch(reason => {})


  return {

    gCategoriesOptions,
    gGroupsOptions,
    gTypesOptions,
    gOwnersOptions,
    gContractsOptions,
    gContractsOptions_orig,
    gDevicesOptions,

    gTypeFilter,
    gGroupFilter,
    gContractsFilter,
    gOwnersFilter,
    gCategoriesFilter,
    gDeviceFilter

  }
}
